export default "CEE Industrie (IND-*) — Primes pour les travaux d'efficacité énergétique industrielle | Solution Éco France";
